import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { CartProvider } from "@/context/CartContext";
import { LanguageProvider } from "@/context/LanguageContext";
import Layout from "@/components/Layout";

import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductPage from "@/pages/ProductPage";
import StoryPage from "@/pages/StoryPage";
import LatviaPage from "@/pages/LatviaPage";
import JournalPage from "@/pages/JournalPage";
import JournalPostPage from "@/pages/JournalPostPage";
import ContactPage from "@/pages/ContactPage";
import FaqPage from "@/pages/FaqPage";
import ShippingPage from "@/pages/ShippingPage";
import PrivacyPage from "@/pages/PrivacyPage";

function App() {
  return (
    <LanguageProvider>
      <CartProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/shop" element={<ShopPage />} />
              <Route path="/shop/:category" element={<ShopPage />} />
              <Route path="/product/:handle" element={<ProductPage />} />
              <Route path="/story" element={<StoryPage />} />
              <Route path="/latvia" element={<LatviaPage />} />
              <Route path="/journal" element={<JournalPage />} />
              <Route path="/journal/:slug" element={<JournalPostPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/shipping" element={<ShippingPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
            </Routes>
          </Layout>
          <Toaster position="bottom-center" richColors={false} toastOptions={{
            style: { background: '#2C1A0E', color: '#F5ECD7', border: 'none', borderRadius: 0, fontFamily: 'Inter' }
          }} />
        </BrowserRouter>
      </CartProvider>
    </LanguageProvider>
  );
}

export default App;
